module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-first-part"
  }, [_c('div', {
    staticClass: "row hidden"
  }, [_c('div', {
    staticClass: "columns small-12 medium-2 large-2"
  }, [_c('ul', {
    staticClass: "footer-list"
  }, [_c('li', {
    staticClass: "footer-list__item"
  }, [_c('a', {
    staticClass: "footer-list__link footer-list__link_bold",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Сервис")])]), _vm._v(" "), _c('li', {
    staticClass: "footer-list__item"
  }, [_c('a', {
    staticClass: "footer-list__link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Сервис")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns small-12 medium-2 large-2"
  }, [_c('ul', {
    staticClass: "footer-list"
  }, [_c('li', {
    staticClass: "footer-list__item"
  }, [_c('a', {
    staticClass: "footer-list__link footer-list__link_bold",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Пациентам")])]), _vm._v(" "), _c('li', {
    staticClass: "footer-list__item"
  }, [_c('a', {
    staticClass: "footer-list__link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Пациентам")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns small-12 medium-5 large-5"
  }, [_c('ul', {
    staticClass: "footer-list"
  }, [_c('li', {
    staticClass: "footer-list__item"
  }, [_c('a', {
    staticClass: "footer-list__link footer-list__link_bold",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Врачам/КлиникамКонтакты")])]), _vm._v(" "), _c('li', {
    staticClass: "footer-list__item"
  }, [_c('a', {
    staticClass: "footer-list__link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Врачам/КлиникамКонтакты")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns small-12 medium-3 large-3"
  }, [_c('ul', {
    staticClass: "footer-list"
  }, [_c('li', {
    staticClass: "footer-list__item"
  }, [_c('a', {
    staticClass: "footer-list__link footer-list__link_bold",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Контакты")])]), _vm._v(" "), _c('li', {
    staticClass: "footer-list__item"
  }, [_c('a', {
    staticClass: "footer-list__link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Контакты")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns small-12 medium-12 large-12"
  }, [_c('div', {
    staticClass: "footer-icons"
  }, [_c('a', {
    staticClass: "footer-icons__link",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "footer-icons__item footer-icons__item_vk"
  }, [_c('i', {
    staticClass: "fa fa-vk",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "footer-icons__link",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "footer-icons__item footer-icons__item_fb"
  }, [_c('i', {
    staticClass: "fa fa-facebook",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "footer-icons__link",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "footer-icons__item footer-icons__item_tw"
  }, [_c('i', {
    staticClass: "fa fa-twitter",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-second-part"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-12 medium-12 large-12"
  }, [_c('p', {
    staticClass: "footer-text"
  }, [_vm._v("Дизайн и разработка студии "), _c('a', {
    attrs: {
      "href": "http://skrymedia.com"
    }
  }, [_vm._v("SkryMedia")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7830d5dd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 633
// module chunks = 0